import React from 'react'
import { Goccia, Info } from '../../atoms/NewIcons'
import { priceNotation } from '../../../utils/safe'
import { useState } from 'react'
import { useEffect } from 'react'
import useTrans from '../../../hooks/useTrans'
import Tooltip from '../../atoms/Tooltip/Tooltip'
import BadgeConsigliato from '../../atoms/NewIcons/BadgeConsigliato'
import BadgeEconomico from '../../atoms/NewIcons/BadgeEconomico'
import GocciaFullColor from '../../atoms/NewIcons/GocciaFullColor'
import GocciaIncisione from '../../atoms/NewIcons/GocciaIncisione'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'

const BadgeTecnica = ({ variant = 'consigliata' }) => {
  const variants = ['consigliata', 'economica']
  const t = useTrans()

  return variants.includes(variant) ? (
    <div
      className={`badgetecnica ${
        variant === 'consigliata'
          ? 'badgetecnica--consigliata'
          : variant === 'economica'
          ? 'badgetecnica--economica'
          : ''
      }`}
    >
      {variant === 'consigliata' ? (
        <BadgeConsigliato />
      ) : variant === 'economica' ? (
        <BadgeEconomico />
      ) : null}
      <span className={'badgetecnica__label'}>
        {variant === 'consigliata'
          ? t('Consigliato')
          : variant === 'economica'
          ? t('Economico')
          : ''}
      </span>
    </div>
  ) : (
    <></>
  )
}

const TecnicaCard = ({
  tecnica,
  selected,
  setSelectedTecnica,
  prezziTecnica,
  quantita,
  disabled,
  consigliata = false,
  economica = false,
}) => {
  const t = useTrans()
  const { service_gift } = useSelector((state) => state.servicegift)
  const [quantitaTotale, setQuantitaTotale] = useState(0)

  const getPrezzoUnitario = () => {
    const prezzoItem =
      prezziTecnica?.posizioni?.[0]?.numero_colori?.[0]?.personalizzazioni_objects?.[0]
    if (!prezzoItem?.prezzi_personalizzazione || quantitaTotale === 0) return null
    const prezzi = prezzoItem.prezzi_personalizzazione
    const prezzo = prezzi
      .filter((p) => quantitaTotale >= p.a_partire_da)
      .sort((a, b) => b.a_partire_da - a.a_partire_da)[0]
    return prezzo ? prezzo.prezzo : prezzi[0].prezzo
  }

  useEffect(() => {
    if (quantita && Array.isArray(quantita)) {
      setQuantitaTotale(quantita.reduce((acc, curr) => acc + (curr.quantita || 0), 0))
    } else {
      setQuantitaTotale(0)
    }
  }, [quantita])


  return (
    <div
      className={`tecnica ${selected ? 'tecnica--selected' : ''} ${
        disabled ? 'tecnica--disabled' : ''
      }`}
      onClick={() => (!disabled ? setSelectedTecnica(tecnica) : undefined)}
    >
      {(economica || consigliata) &&
        (consigliata && service_gift ? null : (
          <BadgeTecnica variant={economica ? 'economica' : 'consigliata'} />
        ))}
      <div className="tecnica__head">
        <div className="tecnica__head__title">{tecnica?.nome}</div>
        {/* <span className="tecnica__head__date">{'2 Giorni'}</span> */}
      </div>
      <div className="tecnica__content">
        <div className="tecnica__colore">
          <p className="tecnica__colori__row">
            <span
              className={`tecnica__colori__icon ${
                !tecnica.posizioni[0].numero_colori[0]?.full_color
                  ? 'tecnica__colori__icon__goccia'
                  : ''
              }`}
            >
              {!tecnica.posizioni[0].numero_colori[0]?.full_color &&
              tecnica.posizioni[0].numero_colori.length > 0 ? (
                [...Array(tecnica.posizioni[0].numero_colori.length)].map((k, i) => (
                  <Goccia key={`tecnica-card-goccia-${i}`} />
                ))
              ) : (
                <span>
                  {tecnica.posizioni[0].numero_colori[0]?.codice === '000' ? (
                    <GocciaFullColor />
                  ) : (
                    <GocciaIncisione />
                  )}
                </span>
              )}
            </span>
            <span className="tecnica__colori__label">
              {tecnica.posizioni[0].numero_colori.length > 0 &&
              tecnica.posizioni[0].numero_colori[0].full_color
                ? tecnica.posizioni[0].numero_colori[0].nome
                : `${t('Max {0} Colore(i)', [tecnica.posizioni[0].numero_colori.length])}`}
            </span>
          </p>
        </div>
        <div className="tecnica__description">{tecnica?.descrizione}</div>
        <div className="tecnica__posizioniTitle">{`- ${t(
          'Posizioni di stampa disponibili'
        )} -`}</div>
        <div className="tecnica__posizioniList">
          {tecnica?.posizioni?.map((posizione, index) => {
            return !!posizione?.numero_colori?.[0]?.personalizzazioni_objects?.[0]
              ?.dimensione_larghezza ||
              !!posizione?.numero_colori?.[0]?.personalizzazioni_objects?.[0]
                ?.dimensione_altezza ? (
              <Tooltip
                key={index}
                label={`${posizione?.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.dimensione_larghezza} x ${posizione?.numero_colori?.[0]?.personalizzazioni_objects?.[0]?.dimensione_altezza} cm`}
                containerClassName="tecnica__posizioniList__item"
              >
                <Info />
                <span className="">{posizione.nome}</span>
              </Tooltip>
            ) : (
              <span key={index} className="tecnica__posizioniList__item">
                {posizione.nome}
              </span>
            )
          })}
        </div>
      </div>
      <div className="tecnica__footer">
        <div>
          {t("Imp")}:{' '}
          {prezziTecnica.costo_impianto ? (
            <>
              {priceNotation(prezziTecnica.costo_impianto, 2)}€{' '}
              {!prezziTecnica.posizioni?.[0]?.numero_colori?.[0]?.full_color && t('colore')}
            </>
          ) : (
            t('gratuito')
          )}
          {' | '}
          Cad: {priceNotation(getPrezzoUnitario(), 3)}€
        </div>
        <Tooltip
          label={t('Il prezzo cad indicato è riferito alla prima posizione di stampa visibile')}
          containerClassName="tecnica__footer__tooltip"
        >
          <Info />
        </Tooltip>
      </div>
    </div>
  )
}

export default TecnicaCard
